<template>
	<div data-spy="scroll" data-target="#navbar" data-offset="20">
		<!--Navbar Start-->
		<nav class="navbar navbar-expand-lg navbar-light fixed-top" id="navbar">
			<div class="container">
				<!-- LOGO -->
				<a href="/" class="navbar-brand logo">
					<img src="/images/logo-dark.png" alt="" class="logo-dark" height="28" />
					<img src="/images/logo-light.png" alt="" class="logo-light" height="28" />
				</a>
				<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu">
						<line x1="3" y1="12" x2="21" y2="12"></line>
						<line x1="3" y1="6" x2="21" y2="6"></line>
						<line x1="3" y1="18" x2="21" y2="18"></line>
					</svg>
				</button>
				<div class="collapse navbar-collapse" id="navbarCollapse">
					<ul class="navbar-nav ms-auto navbar-center" id="navbar-navlist">
						<li class="nav-item">
							<a href="#home" class="nav-link">홈</a>
						</li>
						<li class="nav-item">
							<a href="#board" class="nav-link">공지사항</a>
						</li>
						<li class="nav-item">
							<a href="#services" class="nav-link">서비스</a>
						</li>
						<li class="nav-item">
							<a href="#features" class="nav-link">특징</a>
						</li>
						<li class="nav-item">
							<a href="#contact" class="nav-link">문의하기</a>
						</li>
					</ul>
					<a v-bind:href="link" id="btn-my" class="btn btn-sm rounded-pill nav-btn ms-lg-3">{{ linkText }}</a>
				</div>
			</div>
			<!-- end container -->
		</nav>
		<!-- Navbar End -->

		<!-- Hero Start -->
		<section class="hero-6 bg-center position-relative overflow-hidden" style="background-image: url(images/hero-6-bg.png);" id="home">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-lg-5">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
							class="feather feather-sunrise mb-4 icon-lg sw-1_5 text-primary"
						>
							<path d="M17 18a5 5 0 0 0-10 0"></path>
							<line x1="12" y1="2" x2="12" y2="9"></line>
							<line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line>
							<line x1="1" y1="18" x2="3" y2="18"></line>
							<line x1="21" y1="18" x2="23" y2="18"></line>
							<line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line>
							<line x1="23" y1="22" x2="1" y2="22"></line>
							<polyline points="8 6 12 2 16 6"></polyline>
						</svg>
						<h1 class="font-weight-semibold mb-4 hero-6-title" style="font-size:40px; line-height: 1.5;">쇼핑몰 성공의 열쇠는 정확한 <b>키워드</b> 선택에 있습니다.</h1>
						<p class="mb-5 text-muted">정확한 키워드 선택은 타겟 시장을 정확히 파악하고, 그들이 검색할 만한 용어를 이해하는 것에서 시작됩니다. 그리고 이 키워드들을 지속적으로 모니터링하고 최적화하는 것이 쇼핑몰 성공의 핵심입니다.</p>
						<a href="main/dashboard" class="btn btn-primary me-2"
							>시작하기
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
								<path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" /></svg
						></a>
					</div>
					<div class="col-lg-6 col-sm-10 mx-auto ms-lg-auto me-lg-0">
						<div class="mt-lg-0 mt-5">
							<img src="images/hero-6-img.png" alt="" class="img-xl-responsive" />
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- Hero End -->

		<!-- Notice start -->
		<section class="section bg-light" id="board">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-lg-7 text-center">
						<h2 class="fw-bold">공지사항</h2>
					</div>
				</div>
				<div class="row">
					<table class="table h6">
						<thead>
							<tr>
								<th scope="col"></th>
								<th scope="col"></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in notice" :key="item.noticeNum" @click="viewNotice(item.noticeNum)" class="cursor_pointer">
								<td class="p-3">{{ item.noticeTitle }}</td>
								<td class="p-3 text-end">{{ item.noticeDate }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- end row -->
			</div>
			<!-- end container -->
		</section>
		<!-- Notice end -->

		<!-- Services start -->
		<section class="section" id="services">
			<div class="container">
				<div class="row justify-content-center mb-5">
					<div class="col-lg-7 text-center">
						<h2 class="fw-bold">서비스</h2>
						<p class="text-muted">마이파랑은 쇼핑몰 판매자들의 판매를 돕기 위해 다양한 서비스를 제공합니다.</p>
					</div>
				</div>

				<div class="row">
					<div class="col-lg-4">
						<div class="service-box text-center px-4 py-5 position-relative mb-4 btn" v-on:click="toDashboard">
							<div class="service-box-content p-4">
								<div class="icon-mono service-icon avatar-md mx-auto mb-4">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-box">
										<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
										<polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
										<line x1="12" y1="22.08" x2="12" y2="12"></line>
									</svg>
								</div>
								<h4 class="mb-3 font-size-22">네이버쇼핑 매니저</h4>
								<p class="text-muted mb-0">네이버쇼핑 매니저는 키워드 관리를 통해 광고 예산의 효율적 사용과 더불어, 경쟁력 있는 입찰 전략을 통한 광고 효과의 극대화에 중요한 역할을 합니다.</p>
							</div>
						</div>
					</div>
					<!-- end col -->

					<div class="col-lg-4">
						<div class="service-box text-center px-4 py-5 position-relative mb-4 btn" v-on:click="toAnalytics">
							<div class="service-box-content p-4">
								<div class="icon-mono service-icon avatar-md mx-auto mb-4">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-layers">
										<polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
										<polyline points="2 17 12 22 22 17"></polyline>
										<polyline points="2 12 12 17 22 12"></polyline>
									</svg>
								</div>
								<h4 class="mb-3 font-size-22">개인통관고유부호</h4>
								<p class="text-muted mb-0">개인통관고유부호의 유효성을 검증할 수 있습니다. 사용법이 쉽고 간단하며, 한 번에 여러건 검증도 가능합니다.</p>

								<!-- <h4 class="mb-3 font-size-22">광고성과분석</h4>
								<p class="text-muted mb-0">네이버 쇼핑광고를 상품 및 키워드 단위로 매출성과를 분석해주는 서비스 입니다.</p> -->
							</div>
						</div>
					</div>
					<!-- end col -->

					<div class="col-lg-4">
						<div class="service-box text-center px-4 py-5 position-relative mb-4 btn" v-on:click="toRank">
							<div class="service-box-content p-4">
								<div class="icon-mono service-icon avatar-md mx-auto mb-4">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-server">
										<rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
										<rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
										<line x1="6" y1="6" x2="6.01" y2="6"></line>
										<line x1="6" y1="18" x2="6.01" y2="18"></line>
									</svg>
								</div>
								<h4 class="mb-3 font-size-22">네이버 쇼핑 순위</h4>
								<p class="text-muted mb-0">스마트스토어에서 내 상품이 키워드별로 몇 번째로 검색되는지 한 눈에 파악할 수 있는 서비스 입니다.</p>
							</div>
						</div>
					</div>
					<!-- end col -->
				</div>
				<!-- end row -->
			</div>
			<!-- end container -->
		</section>
		<!-- Services end -->

		<!-- Features start -->
		<section class="section bg-light" id="features">
			<div class="container">
				<div class="row justify-content-center mb-5">
					<div class="col-lg-7 text-center">
						<h2 class="fw-bold">특징</h2>
						<p class="text-muted">네이버쇼핑 매니저는 광고매출과 총 매출을 비교하여 적절한 키워드 선택을 돕고, 광고 예산의 효율적 사용과 더불어, 경쟁력 있는 입찰 전략을 통한 광고 효과의 극대화에 중요한 역할을 합니다.</p>
					</div>
				</div>

				<!-- Features 1 -->
				<div class="row align-items-center mb-5">
					<div class="col-md-5 order-2 order-md-1 mt-md-0 mt-5">
						<h2 class="mb-4">총매출 대비 광고수익률 극대화</h2>
						<p class="text-muted mb-0">광고수익률(ROAS)보다 중요한 건 총매출 대비 광고수익률(T-ROAS)입니다.</p>
						<p class="text-muted mb-5">마이파랑은 네이버 검색광고 전환 매출 뿐 아니라 스마트스토어 상품 단위의 총 매출 대비 광고수익률(T-ROAS) 또한 제공합니다.</p>
						<a href="main/dashboard" class="btn btn-primary"
							>더 알아보기<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
								<path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" /></svg
						></a>
					</div>
					<div class="col-md-6 ms-md-auto order-1 order-md-2">
						<div class="position-relative">
							<div class="ms-5 features-img">
								<img src="images/features-1.jpg" alt="" class="img-fluid d-block mx-auto rounded shadow" />
							</div>
							<img src="images/dot-img.png" alt="" class="dot-img-left" />
						</div>
					</div>
				</div>
				<!-- Features 2-->
				<div class="row align-items-center section">
					<div class="col-md-6">
						<div class="position-relative mb-md-0 mb-5">
							<div class="me-5 features-img">
								<img src="images/hero-9-bg.jpg" alt="" class="img-fluid d-block mx-auto rounded shadow" />
							</div>
							<img src="images/dot-img.png" alt="" class="dot-img-right" />
						</div>
					</div>
					<div class="col-md-5 ms-md-auto">
						<h2 class="mb-4">키워드 타겟팅</h2>
						<p class="text-muted mb-0">검색광고의 핵심은 정확한 키워드 타겟팅입니다.</p>
						<p class="text-muted mb-5">마이파랑은 필터링 기능을 통해 캠페인 단위가 아닌 키워드 단위의 데이터를 확인할 수 있습니다.</p>
						<a href="main/analytics" class="btn btn-primary"
							>더 알아보기
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
								<path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" /></svg
						></a>
					</div>
				</div>
				<!-- Features 3 -->
				<div class="row align-items-center mb-5">
					<div class="col-md-5 order-2 order-md-1 mt-md-0 mt-5">
						<h2 class="mb-4">자동 입찰 및 키워드 관리 (준비중)</h2>
						<p class="text-muted mb-0">향상된 자동 입찰 기능을 통해 광고 수익률을 극대화합니다.</p>
						<p class="text-muted mb-5">타겟 키워드 관리 기능을 통해 노출을 원하지 않는 키워드를 자동으로 제외키워드로 등록됩니다.</p>
						<!-- <a href="main/rank" class="btn btn-primary"
							>더 알아보기
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
								<path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" /></svg
						></a> -->
					</div>
					<div class="col-md-6 ms-md-auto order-1 order-md-2">
						<div class="position-relative">
							<div class="ms-5 features-img">
								<img src="images/features-2.jpg" alt="" class="img-fluid d-block mx-auto rounded shadow" />
							</div>
							<img src="images/dot-img.png" alt="" class="dot-img-left" />
						</div>
					</div>
				</div>
				<!-- end row -->
			</div>
			<!-- end container -->
		</section>
		<!-- Features end -->
		<!-- Contact us start -->
		<section class="section" id="contact">
			<div class="container">
				<div class="row">
					<div class="col-lg-6 ms-lg-auto">
						<div class="mt-5 mt-lg-0">
							<img src="images/contact.png" alt="" class="img-fluid d-block" />
						</div>
					</div>
					<div class="col-lg-6">
						<h2 class="fw-bold mb-4">문의하기</h2>
						<p class="text-muted ">마이파랑에 대한 문의사항은 우측하단 채널톡, 네이버톡톡을 이용하거나,</p>
						<p class="text-muted ">아래 이메일로 문의 부탁드립니다.</p>

						<div>
							<form method="post" name="myForm" onsubmit="return validateForm()">
								<p id="error-msg"></p>
								<div id="simple-msg"></div>
								<div class="row">
									<div class="col-md-12 mb-4">
										<p>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												stroke="currentColor"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
												class="feather feather-mail me-2 text-muted icon icon-xs mt-1"
											>
												<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
												<polyline points="22,6 12,13 2,6"></polyline>
											</svg>

											myparang.io@gmail.com
										</p>
									</div>
									<div class="col-md-12 mb-4">
										<ul class="list-inline pt-4">
											<li class="list-inline-item me-3">
												<a target="blank" href="https://www.youtube.com/@myparang.official" class="social-icon icon-mono avatar-xs rounded-circle"
													><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-youtube" viewBox="0 0 16 16">
														<path
															d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z"
														/></svg
												></a>
											</li>
											<li class="list-inline-item me-3">
												<a target="blank" href="https://www.instagram.com/myparang.io/" class="social-icon icon-mono avatar-xs rounded-circle"
													><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-instagram" viewBox="0 0 16 16">
														<path
															d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"
														/></svg
												></a>
											</li>
											<li class="list-inline-item">
												<a target="blank" id="a_ncafe2" href="https://cafe.naver.com/oliviewlabs" class="social-icon icon-mono avatar-xs rounded-circle"><img src="images/ncafe.png"/></a>
											</li>
										</ul>
									</div>
								</div>
							</form>
						</div>
					</div>
					<!-- end col -->

					<!-- end col -->
				</div>
				<!-- end row -->
			</div>
			<!-- end container -->
		</section>
		<!-- Contact us end -->

		<!-- Footer Start -->
		<footer class="footer" style="background-image: url(images/footer-bg.png);">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<div class="mb-4">
							<a href="/"><img src="/images/logo-light.png" alt="" class="" height="30"/></a>
						</div>
					</div>
					<!-- end col -->

					<div class="col-lg-12 ms-lg-auto">
						<div class="row">
							<div class="col-12">
								<div class="mt-4 mt-lg-0">
									<ul class="list-unstyled footer-sub-menu">
										<li><a href="javascript: void(0);" class="footer-link">상호명 : 마이파랑</a></li>
										<li><a href="javascript: void(0);" class="footer-link">대표 : 오한식</a></li>
										<li><a href="javascript: void(0);" class="footer-link">이메일 : myparang.io@gmail.com</a></li>
										<li><a href="javascript: void(0);" class="footer-link">사업장소재지 : 경기 안양시 동안구 엘에스로 142 B102호</a></li>
										<li><a href="javascript: void(0);" class="footer-link">통신판매업신고 : 제 2022-안양동안-0130 호</a></li>
										<li><a href="javascript: void(0);" class="footer-link">사업자등록번호 : 599-35-00633</a></li>
										<li><a href="javascript: void(0);" class="footer-link">Copyright(c) MyParang. All rights reserved</a></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<!-- end col -->
				</div>
				<!-- end row -->

				<div class="row">
					<div class="col-lg-12">
						<div class="text-center mt-5">
							<p class="text-white-50 f-15 mb-0"></p>
						</div>
					</div>
					<!-- end col -->
				</div>
				<!-- end row -->
			</div>
			<!-- end container -->
		</footer>
		<!-- Footer End -->
	</div>
</template>

<script>
import Swal from "../../js/sweetalert2.min.js";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.xsrfCookieName = "XSRF-TOKEN";
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";

export default {
	data() {
		return {
			link: "/signin",
			linkText: "로그인",
			notice: []
		};
	},
	beforeMount() {
		this.checkSignin();
		this.getNotice();
	},
	mounted() {},
	methods: {
		checkSignin: function(e) {
			var loginCookie = this.$cookies.get("MID");
			if (loginCookie != undefined && loginCookie != "0") {
				this.link = "/user/myinfo";
				this.linkText = "내정보";
			} else {
				this.link = "/signin";
				this.linkText = "로그인";
			}
		},
		getNotice() {
			axios
				.get("/board/getNoticePage/0")
				.then(response => {
					Swal.close();
					for (let i = 0; i < response.data.content.length; i++) {
						response.data.content[i].noticeDate = this.dateformatByStr(response.data.content[i].noticeDate);
					}
					this.notice = response.data.content;
				})
				.catch(error => {
					this.invalidSession(error);
				});
		},
		viewNotice(noticeNum) {
			this.$router.push("/notice/" + noticeNum).then(() => {
				this.$nextTick(() => {
					window.scrollTo(0, 0); // 화면 상단으로 스크롤
				});
			});
		},
		dateformat(current_datetime) {
			var month = current_datetime.getMonth() + 1;
			if (month < 10) {
				month = "0" + month;
			}
			var day = current_datetime.getDate();
			if (day < 10) {
				day = "0" + day;
			}
			let formatted_date = current_datetime.getFullYear() + "년 " + month + "월 " + day + "일";
			return formatted_date;
		},
		dateformatByDate(date) {
			const year = date.getFullYear(); // 연도를 가져옴
			const month = String(date.getMonth() + 1).padStart(2, "0"); // 월을 가져오며, 1월이 0이므로 +1, 두 자리로 맞춤
			const day = String(date.getDate()).padStart(2, "0"); // 일을 가져오며, 두 자리로 맞춤
			const hour = String(date.getHours()).padStart(2, "0"); // 일을 가져오며, 두 자리로 맞춤
			const minute = String(date.getMinutes()).padStart(2, "0"); // 일을 가져오며, 두 자리로 맞춤

			return `${year}. ${month}. ${day}.`;
		},
		dateformatByTimestamp(timestamp) {
			const date = new Date(timestamp * 1000); // timestamp를 Date 객체로 변환
			return this.dateformatByDate(date);
		},
		dateformatByStr(str) {
			const date = new Date(str); // timestamp를 Date 객체로 변환
			return this.dateformatByDate(date);
		},

		toDashboard: function() {
			location.href = "/main/dashboard";
		},
		toAnalytics: function() {
			location.href = "/main/pc4";
			//location.href = "/main/analytics";
		},
		toRank: function() {
			location.href = "/main/rank";
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Intro.vue